import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class UnauthorizedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
    }
}
export class InvalidSubscriptionError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidSubscriptionError";
    }
}
export class DomainIsCNameError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "DomainIsCNameError";
    }
}
export class ForbiddenError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ForbiddenError";
    }
}
export class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
export class DomainAlreadyExistError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "DomainAlreadyExistError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    InvalidParameterError,
    UnauthorizedError,
    InvalidSubscriptionError,
    DomainIsCNameError,
    ForbiddenError,
    NotFoundError,
    DomainAlreadyExistError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
